import { render, staticRenderFns } from "./englishJournals.vue?vue&type=template&id=5bc098d6&scoped=true"
import script from "./englishJournals.vue?vue&type=script&lang=js"
export * from "./englishJournals.vue?vue&type=script&lang=js"
import style0 from "./englishJournals.vue?vue&type=style&index=0&id=5bc098d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc098d6",
  null
  
)

export default component.exports